import { PropTypes } from 'prop-types';
import React from 'react';

const CardLargeType = ({ data: { header }, long = false }) => (
  <div className={`large-type ${long ? 'long' : ''}`}>
    <div className={`header ${long ? 'long' : ''}`}>{header}</div>
  </div>
);

CardLargeType.propTypes = {
  data: PropTypes.object,
  long: PropTypes.bool,
};

export default CardLargeType;
